export enum StandardConfigurationType {
  None = 1,
  Custom = 2
}